import styled, { css, keyframes } from "styled-components";
import { lighten } from "polished";

type ModalProps = {
  isVisible: boolean;
};

const ModalScale = keyframes`
  from {
    transform: scale(0.5);
    opacity: 0.4;
  }
  to {
    transform: scale(1);
    opacity: 1;
  }
`;

export const ContainerOverlay = styled.aside<ModalProps>`
  ${({ theme, isVisible }) => css`
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    display: ${isVisible ? "flex" : "none"};
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.5);
    z-index: ${theme.layers.alwaysOnTop};
  `}
`;

export const BoxModal = styled.div`
  ${({ theme }) => css`
    width: 90%;
    height: 90%;
    padding: 0 16px 16px;
    border-radius: 10px;
    flex-direction: column;
    background-color: ${theme.colors.background_modal};
    animation: ${ModalScale} 0.3s ease-in-out;
  `}
`;

export const Header = styled.div`
  width: 100%;
  height: 56px;
  margin-bottom: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;

  & > button {
    border-radius: 6px;
    transition: background 0.2s;

    &:hover {
      background: ${({ theme }) => lighten(0.1, theme.colors.background_modal)};
    }
  }
`;

export const Main = styled.div`
  width: 100%;
  height: 90%;
  min-height: 150px;
  display: flex;
  overflow: auto;
`;

export const Title = styled.h4`
  font-size: 18px;
  color: rgba(255, 255, 255, 0.87);
  text-align: center;
  margin-bottom: 12px;
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.medium};
    color: ${theme.colors.text};
    margin: 0 8px;
    text-align: justify;
    max-height: 100px;
    display: flex;
    flex-direction: column;
    margin-right: 20px;
  `}
`;
